import { makeVar } from "shared/providers/apollo/apollo.package";

export const portfolioSwitchingVar = makeVar(false);

export const resetPortfolioSwitchingVar = () => portfolioSwitchingVar(false);
